import ExcelJS from "exceljs";
import { saveAs } from "file-saver";
export const commonDistributionExcel = async (
  data,
  headerStyle,
  subtotalStyle,
  totalStyle,
  title = "Branch Wise Summary Report" // <-- Added title param
) => {
  const workbook = new ExcelJS.Workbook();
  const sheet = workbook.addWorksheet("Branch Summary");

  // ---- Determine branch columns ----
  const branches = data.map((b) => b.branchName);
  const columnsPerBranch = 4;
  const totalColumns = 1 + branches.length * columnsPerBranch;

  // ---- Title row ----
// ---- Title row ----
const titleRow = sheet.addRow([]);
sheet.mergeCells(1, 2, 1, totalColumns); // merge from column 2 to totalColumns
sheet.getCell(1, 2).value = title;        // set title in second column
sheet.getCell(1, 2).font = { bold: true, size: 16 };
sheet.getCell(1, 2).alignment = { vertical: "middle", horizontal: "left" };
titleRow.height = 25;


  // ---- Printed date row ----
  const printDate = new Date().toLocaleDateString("en-GB"); // e.g. 23/10/2025
  const dateRow = sheet.addRow([`Printed Date: ${printDate}`]);
  sheet.mergeCells(2, 1, 2, totalColumns);
  dateRow.alignment = { horizontal: "left" };
  dateRow.font = { italic: true, size: 11, color: { argb: "FF555555" } };

  // ---- Header rows start from row 3 ----
  const headerStartRow = 3;
  const amountFormat = '#,##0.00';


  sheet.mergeCells(headerStartRow, 1, headerStartRow + 1, 1);
  sheet.getCell(headerStartRow, 1).value = "Months";
  sheet.getCell(headerStartRow, 1).style = headerStyle;

  branches.forEach((branch, index) => {
    const startCol = 2 + index * columnsPerBranch;
    const endCol = startCol + columnsPerBranch - 1;
    sheet.mergeCells(headerStartRow, startCol, headerStartRow, endCol);
    sheet.getCell(headerStartRow, startCol).value = branch;
    sheet.getCell(headerStartRow, startCol).style = headerStyle;

    const headers = ["accountNumber", "accountType", "name", "amount"];
    headers.forEach((h, i) => {
      const cell = sheet.getCell(headerStartRow + 1, startCol + i);
      cell.value = h;
      cell.style = headerStyle;
    });
  });

  let currentRow = headerStartRow + 2;

  // ---- Unique months ----
  const months = [...new Set(data.flatMap((b) => b.monthList.map((m) => m.month)))];
  months.sort((a, b) => new Date(a) - new Date(b));


  months.forEach((month) => {
    const maxAccounts = Math.max(
      ...data.map((b) => {
        const monthData = b.monthList.find((m) => m.month === month);
        return monthData ? monthData.accountList.length : 0;
      })
    );

    for (let i = 0; i < maxAccounts; i++) {
      const row = [];
      row[1] = month;
      // row[1] = i === 0 ? month : "";

      data.forEach((b) => {
        const monthData = b.monthList.find((m) => m.month === month);
        const account = monthData?.accountList[i];
        if (account) {
          row.push(
            account.accountNumber,
            account.accountType,
            account.name,
            account.amount
          );
        } else {
          row.push("", "", "", "");
        }
      });



      const addedRow = sheet.addRow(row);

      addedRow.eachCell((cell, colNumber) => {
        if ((colNumber - 2) % 4 === 3) { // every 4th column after branch start is 'amount'
          cell.numFmt = amountFormat;
        }
      });

      // Even row background color
      if (addedRow.number % 2 === 0) {
        addedRow.eachCell((cell) => {
          cell.fill = {
            type: "pattern",
            pattern: "solid",
            fgColor: { argb: "FFEFEFEF" },
          };
        });
      }
      currentRow++;
    }

    // ---- Subtotal per month ----
    const subtotalRow = ["Sub Total"];
    data.forEach((b) => {
      const monthData = b.monthList.find((m) => m.month === month);
      const subTotal = monthData
        ? monthData.accountList.reduce((sum, a) => sum + a.amount, 0)
        : 0;
      subtotalRow.push("", "", "", subTotal);
    });

    const addedSubtotalRow = sheet.addRow(subtotalRow);

    addedSubtotalRow.eachCell((cell, colNumber) => {
      cell.style = subtotalStyle;
      if ((colNumber - 2) % 4 === 3) cell.numFmt = amountFormat; // format subtotal amounts
    });

    addedSubtotalRow.eachCell((cell) => {
      cell.style = subtotalStyle;
    });
    currentRow++;
  });

  // ---- Grand Total ----
  const totalRow = ["Grand Total"];
  data.forEach((b) => {
    const total = b.monthList.reduce(
      (sum, m) => sum + m.accountList.reduce((s, a) => s + a.amount, 0),
      0
    );
    totalRow.push("", "", "", total);
  });

  const addedTotalRow = sheet.addRow(totalRow);

  addedTotalRow.eachCell((cell, colNumber) => {
    cell.style = totalStyle;
    if ((colNumber - 2) % 4 === 3) cell.numFmt = amountFormat; // format grand total amounts
  });

  addedTotalRow.eachCell((cell) => {
    cell.style = totalStyle;
  });

  // ---- Column widths & frozen panes ----
  for (let i = 1; i <= totalColumns; i++) {
    sheet.getColumn(i).width = i === 1 ? 30 : 20;
  }

  // Freeze top 4 rows (title + date + 2 header rows)
  sheet.views = [{ state: "frozen", xSplit: 1, ySplit: headerStartRow + 1 }];

  // ---- Export Excel ----
  const buffer = await workbook.xlsx.writeBuffer();
  const blob = new Blob([buffer], {
    type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
  });

  saveAs(blob, `${title.replace(/\s+/g, "_")}.xlsx`);
};
